export default "__VITE_ASSET__1577bb4b__"